import PropTypes from 'prop-types';
import { useEffect } from 'react';
// @mui
import List from '@mui/material/List';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
// hooks
import { useBoolean } from 'src/hooks/useBoolean';
// routes
import { usePathname } from 'src/routes/hooks';
// components
import Scrollbar from 'src/components/scrollbar';
import Iconify from 'src/components/iconify';
import NavList from 'src/layouts/main/nav-mobile/nav-list';
import Logo from 'src/components/logo';

// ----------------------------------------------------------------------

export default function NavMobile({ offsetTop, data }) {
  const nav = useBoolean();
  const pathname = usePathname();

  useEffect(() => {
    if (nav.value) {
      nav.onFalse();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <>
      <IconButton
        onClick={nav.onTrue}
        sx={{
          ...(offsetTop && {
            color: 'text.primary',
          }),
        }}
      >
        <Iconify icon="material-symbols:menu-rounded" width={30} />
      </IconButton>

      <Drawer
        open={nav.value}
        onClose={nav.onFalse}
        PaperProps={{
          sx: {
            pb: 5,
            width: 200,
          },
        }}
      >
        {nav.value ? (
          <>
            <Logo disabledLink width={20} sx={{ mb: 2, ml: 2, mt: 2 }} small={false} />
            <Scrollbar>
              <List component="nav" disablePadding>
                {data.map((link) => (
                  <NavList key={link.title} item={link} />
                ))}
                <Divider />
              </List>
            </Scrollbar>
          </>
        ) : null}
      </Drawer>
    </>
  );
}

NavMobile.propTypes = {
  data: PropTypes.array,
  offsetTop: PropTypes.bool,
};
